import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add preconnect for Amazon S3 to speed up image loading
const head = document.head;
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://uploadthingy.s3.us-west-1.amazonaws.com';
head.appendChild(preconnect);
render(<App data-id="element-269" />, document.getElementById('root'));